import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as cloneDeep from 'lodash/cloneDeep';

import { PortfolioAssetDetailsResponse } from '../../models';
import * as fromHoldingResolutions from './portfolio-holdings-resolution.reducers';

export const holdingsResolutionKey = 'portfolioAssetDetailsResponses';

const getHoldingsResolutionState = createFeatureSelector<fromHoldingResolutions.PortfolioHoldingsResolutionState>(
	holdingsResolutionKey
);

export const selectAllPortfolioAssetDetailsResponses = createSelector(
	getHoldingsResolutionState,
	fromHoldingResolutions.selectAllPortfolioAssetDetailsResponse
);

export const getUnsupportedPortfolioAssetDetailsResponses = createSelector(
	selectAllPortfolioAssetDetailsResponses,
	(portfolioAssetDetailsResponses: PortfolioAssetDetailsResponse[]) => (portfolioAssetDetailsResponses ?? [])
		.map(portfolioAssetDetailsResponses => {
			const filteredHoldings = portfolioAssetDetailsResponses.holdings.filter(holding => holding.assets?.length === 0);
			const responseClone = cloneDeep(portfolioAssetDetailsResponses);
			responseClone.holdings = filteredHoldings;
			return responseClone;
		}).filter(portfolioAssetDetailsResponses => portfolioAssetDetailsResponses.holdings.length > 0)
);
